import React from 'react'
import { ProductCategoryType } from '@leid/api-products'
import { useRouter } from 'next/navigation'

import { convertSerachParamsToURLSearchParams } from 'app/utils/urls'
import { getCategoryName, getCategoryURLParts } from 'components/nav/CategoriesMenu/utils/categories'
import CategoryDrawer from './CategoryDrawer'
import { Category } from 'app/utils/helpers/helpers'

type Props = {
  isBundles: boolean
  searchCategory?: string
  allCategories: Category[]
  queryParams: {
    [key: string]: string | string[] | undefined
  }
  startTransition: (cb: () => void) => void
}
const CategoryDropdown = ({ isBundles, searchCategory, allCategories, queryParams, startTransition }: Props) => {
  const router = useRouter()

  const categoriesToShow = allCategories.filter(
    (s) => s.parentCategoryId === undefined && s.type === ProductCategoryType.FUNCTIONS,
  )

  const handleSelectCategory = (category: Category) => {
    queryParams.searchTerm = undefined
    queryParams.page = undefined
    queryParams.location = undefined
    queryParams.manager = undefined

    if (isBundles) {
      const categoryLink = getCategoryName(category)
      const newCategoryQueryName = categoryLink === searchCategory ? '' : categoryLink

      queryParams.category = newCategoryQueryName

      const params = convertSerachParamsToURLSearchParams(queryParams)
      startTransition(() => {
        router.push(`/bundles?${params.toString()}`)
      })
    } else {
      const url = `/${getCategoryURLParts(category, allCategories)}`
      console.log({ url })

      const params = convertSerachParamsToURLSearchParams(queryParams)
      startTransition(() => {
        router.push(`/browse${url}?${params.toString()}`)
      })
    }
  }

  return <CategoryDrawer categoriesToShow={categoriesToShow} handleSelectCategory={handleSelectCategory} />
}

export default CategoryDropdown
